import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class ClearAutoplayButtonControl extends AbstractButtonControl implements Control {
    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        this.button.on(ButtonEvent.CLICK, () => this.clearAutoplay());
    }

    protected clearAutoplay() {
        const options = new ControlOptions();
        options.flashLossLimit = false;
        options.autoplays.currentValue = 0;
        options.lossLimit.currentValue = this.options.lossLimit.defaultValue;
        options.singleWinLimit.currentValue = this.options.singleWinLimit.defaultValue;
        options.totalWinLimit.currentValue = this.options.totalWinLimit.defaultValue;
        options.customLossLimitSelected = false;
        options.customAutoplayCountSelected = false;
        options.customSingleWinLimitSelected = false;

        this.onChange.dispatch(options);
    }
}
